import CopyPositionsPage from '@/modules/copy-positions/copy-positions-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/copy-positions/')({
  beforeLoad: () => requireCapability('placeOrders'),
  component: RouteComponent
});

function RouteComponent() {
  return <CopyPositionsPage />;
}
